import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export const TRACKING_NETWORK_SCHEMA = Object.freeze({
  URL: '',
  HTTP_CODE: '',
  CORRELATION_ID: '',
  HTTP_MESSAGE: '',
  DESCRIPTION: '',
  INTERNAL_CODE: '',
});
const RECORD = generateSchema(TRACKING_NETWORK_SCHEMA);
const KEYS: any = generateKeys(TRACKING_NETWORK_SCHEMA);

export class NetworkTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.network;
  }

  get properties() {
    return this.toJS();
  }
}
